import Chart from "chart.js/auto";
import ColorThemeAwareDiagram from './color-theme-aware-diagram.js'

export default class ActivityChart extends ColorThemeAwareDiagram {
  constructor() {
    super();

    this.datasetSelector = this.dataset.datasetSelector || 'tr.dataset'
  }

  connectedCallback() {
    window.setTimeout(this.connect.bind(this), 100);
  }

  connect() {
    const canvas = this.querySelector('canvas');

    if (canvas) {
      var chartCtx  = canvas.getContext('2d');
      var chartData = {
        labels: [],
        datasets: [{
          type: 'bar',
          data: [],
          label: window.I18n.t('js.chart.activity'),
          borderColor: `rgba(${this.graphColors[0]},0.9)`,
          backgroundColor: `rgba(${this.graphColors[0]},0.6)`,
          yAxisID: 'axisActivity',
        }, {
          label: window.I18n.t('js.chart.avg_temperature'),
          data: [],
          borderColor: `rgba(${this.graphColors[2]},0.9)`,
          borderWidth: 1,
          fill: false,
          cubicInterpolationMode: 'monotone',
          yAxisID: 'axisTemperature',
        }, {
          label: window.I18n.t('js.chart.avg_humidity'),
          data: [],
          borderColor: `rgba(${this.graphColors[3]},0.9)`,
          borderWidth: 1,
          fill: false,
          cubicInterpolationMode: 'monotone',
          yAxisID: 'axisHumidity',
        }, {
          label: window.I18n.t('js.chart.forecast_min'),
          data: [],
          borderColor: `rgba(140,140,140,0)`,
          pointRadius: 0,
          fill: false,
          cubicInterpolationMode: 'monotone',
          yAxisID: 'axisActivity',
        }, {
          label: window.I18n.t('js.chart.forecast_max'),
          data: [],
          borderColor: `rgba(140,140,140,0)`,
          backgroundColor: `rgba(140,140,140,0.18)`,
          pointRadius: 0,
          fill: '-1',
          cubicInterpolationMode: 'monotone',
          yAxisID: 'axisActivity',
        }, {
          label: window.I18n.t('js.chart.forecast_temperature'),
          data: [],
          borderColor: `rgba(${this.graphColors[2]},0.4)`,
          borderWidth: 1,
          fill: false,
          cubicInterpolationMode: 'monotone',
          yAxisID: 'axisTemperature',
        }, {
          label: window.I18n.t('js.chart.forecast_humidity'),
          data: [],
          borderColor: `rgba(${this.graphColors[3]},0.4)`,
          borderWidth: 1,
          fill: false,
          cubicInterpolationMode: 'monotone',
          yAxisID: 'axisHumidity',
        }, {
          // Prediction uncertainty fan — outer band (90% posterior mass).
          // Lower bound: invisible line the band above fills down to.
          label: this.dataset.predictionLabel || 'Prediction (model)',
          data: [],
          borderColor: `rgba(20,160,120,0)`,
          pointRadius: 0,
          fill: false,
          cubicInterpolationMode: 'monotone',
          yAxisID: 'axisActivity',
        }, {
          // Outer band upper bound — fills down to the 90% lower bound (faint).
          label: this.dataset.predictionLabel || 'Prediction (model)',
          data: [],
          borderColor: `rgba(20,160,120,0)`,
          backgroundColor: `rgba(20,160,120,0.12)`,
          pointRadius: 0,
          fill: '-1',
          cubicInterpolationMode: 'monotone',
          yAxisID: 'axisActivity',
        }, {
          // Inner band (50% posterior mass) lower bound — invisible.
          label: this.dataset.predictionLabel || 'Prediction (model)',
          data: [],
          borderColor: `rgba(20,160,120,0)`,
          pointRadius: 0,
          fill: false,
          cubicInterpolationMode: 'monotone',
          yAxisID: 'axisActivity',
        }, {
          // Inner band upper bound — fills down to the 50% lower bound, drawn on
          // top of the outer band so the dense core reads darker than the tails.
          label: this.dataset.predictionLabel || 'Prediction (model)',
          data: [],
          borderColor: `rgba(20,160,120,0)`,
          backgroundColor: `rgba(20,160,120,0.22)`,
          pointRadius: 0,
          fill: '-1',
          cubicInterpolationMode: 'monotone',
          yAxisID: 'axisActivity',
        }, {
          // Observed temperature range — min/max band around the avg-temp line.
          // Lower bound: invisible line the band above fills down to.
          label: window.I18n.t('js.chart.min_temperature'),
          data: [],
          borderColor: `rgba(${this.graphColors[2]},0)`,
          pointRadius: 0,
          fill: false,
          cubicInterpolationMode: 'monotone',
          order: 1,
          yAxisID: 'axisTemperature',
        }, {
          label: window.I18n.t('js.chart.max_temperature'),
          data: [],
          borderColor: `rgba(${this.graphColors[2]},0)`,
          backgroundColor: `rgba(${this.graphColors[2]},0.15)`,
          pointRadius: 0,
          fill: '-1',
          cubicInterpolationMode: 'monotone',
          order: 1,
          yAxisID: 'axisTemperature',
        }]
      };
      Chart.defaults.plugins.legend = {
        display: false
      }

      let datasets = this.querySelectorAll(this.datasetSelector);
      datasets.forEach((dataset, n) => {
        let dateTd          = dataset.querySelector('.activity-date');
        let quantityTd      = dataset.querySelector('.activity-quantity');
        let temperatureTd   = dataset.querySelector('.activity-temperature');
        let temperatureMinTd = dataset.querySelector('.activity-temperature-min');
        let temperatureMaxTd = dataset.querySelector('.activity-temperature-max');
        let humidityTd      = dataset.querySelector('.activity-humidity');
        let forecastMinTd   = dataset.querySelector('.activity-proj_min');
        let forecastMaxTd   = dataset.querySelector('.activity-proj_max');
        let predMin90Td     = dataset.querySelector('.activity-pred_min90');
        let predMax90Td     = dataset.querySelector('.activity-pred_max90');
        let predMin50Td     = dataset.querySelector('.activity-pred_min50');
        let predMax50Td     = dataset.querySelector('.activity-pred_max50');
        let FcTemperatureTd = dataset.querySelector('.activity-temperature-forecast');
        let FcHumidityTd    = dataset.querySelector('.activity-humidity-forecast');

        dataset.classList.add('visually-hidden');

        quantityTd.style.backgroundColor = `rgba(${this.graphColors[0]},0.9)`;
        quantityTd.style.color           = '#fff';
        quantityTd.style.fontWeight      = 'bold';
        quantityTd.style.textAlign       = 'center';

        chartData.labels[n]           = dateTd.innerText;
        chartData.datasets[0].data[n] = parseInt(quantityTd.innerText);
        chartData.datasets[1].data[n] = parseFloat(temperatureTd.innerText);
        chartData.datasets[2].data[n] = parseFloat(humidityTd.innerText);
        chartData.datasets[3].data[n] = parseInt(forecastMinTd.innerText);
        chartData.datasets[4].data[n] = parseInt(forecastMaxTd.innerText);
        chartData.datasets[5].data[n] = parseFloat(FcTemperatureTd.innerText);
        chartData.datasets[6].data[n] = parseFloat(FcHumidityTd.innerText);
        // Blank cells (model abstained / unsure / no record) parse to NaN and,
        // with spanGaps:true, gap out on the prediction band — intended.
        chartData.datasets[7].data[n] = parseInt(predMin90Td.innerText);
        chartData.datasets[8].data[n] = parseInt(predMax90Td.innerText);
        chartData.datasets[9].data[n] = parseInt(predMin50Td.innerText);
        chartData.datasets[10].data[n] = parseInt(predMax50Td.innerText);
        chartData.datasets[11].data[n] = parseFloat(temperatureMinTd.innerText);
        chartData.datasets[12].data[n] = parseFloat(temperatureMaxTd.innerText);
      });

      new Chart(chartCtx, {
        type: 'line',
        data: chartData,
        options: {
          spanGaps: true,
          animation: false,
          legend: {
            display: false
          },
          scales: {
            axisActivity: {
              type: 'linear',
              position: 'left',
              beginAtZero: true,
              title: {
                display: true,
                text: window.I18n.t('js.chart.activity'),
                color: `rgba(${this.graphColors[0]},0.9)`
              },
              gridLines: {
                display: false,
              },
              ticks: {
                min: 0
              }
            },
            axisTemperature: {
              type: 'linear',
              position: 'right',
              title: {
                display: true,
                text: window.I18n.t('js.chart.avg_temperature'),
                color: `rgba(${this.graphColors[2]},0.9)`
              },
              gridLines: {
                display: true,
                zeroLineColor: 'rgba(100, 100, 240, 0.5)'
              },
              ticks: {
                max: 25,
                min: -10,
                callback: function(value) { return `${value}°C` }
              }
            },
            axisHumidity: {
              type: 'linear',
              position: 'right',
              title: {
                display: true,
                text: window.I18n.t('js.chart.avg_humidity'),
                color: `rgba(${this.graphColors[3]},0.9)`
              },
              gridLines: {
                display: false
              },
              ticks: {
                max: 100,
                min: 0,
                callback: function(value) { return '' + value + '%' }
              }
            }/*, {
              id: 'axis-min-activity',
              type: 'linear',
              position: 'left',
              beginAtZero: true,
              scaleLabel: {
                display: true,
                text: 'Aktivität: min',
                color: "rgba(${this.graphColors[0]},0.9)"
              },
              gridLines: {
                display: false,
              },
              ticks: {
                min: 0
              }
            }, {
              id: 'axis-max-activity',
              type: 'linear',
              position: 'left',
              beginAtZero: true,
              scaleLabel: {
                display: true,
                text: 'Aktivität: max',
                color: "rgba(${this.graphColors[0]},0.9)"
              },
              gridLines: {
                display: false,
              },
              ticks: {
                min: 0
              }
            }*/
          }
        }
      });
    } else {
      console.log('no <canvas> found within <activity-chart>!');
    }

  }
}

customElements.define('activity-chart', ActivityChart);
